import React from 'react';
import { Card, Switch, Typography, Space } from 'antd';
import { useAtom } from 'jotai';
import { showReasoningAtom, showActionButtonsAtom } from '../NexaStore';

const { Title, Paragraph, Text } = Typography;

export const Options: React.FC = () => {
  const [showReasoning, setShowReasoning] = useAtom(showReasoningAtom);
  const [showActionButtons, setShowActionButtons] = useAtom(showActionButtonsAtom);

  return (
    <Card>
      <Title level={4}>Options</Title>

      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ flex: 1 }}>
              <Text strong>Show Reasoning</Text>
              <Paragraph style={{ marginTop: 8, marginBottom: 0 }}>
                <Text type="secondary">
                  Display the agent&apos;s thought process and reasoning steps as it works through
                  your queries. This can help you understand how Nexa arrives at its conclusions.
                </Text>
              </Paragraph>
            </div>
            <Switch
              checked={showReasoning}
              onChange={setShowReasoning}
              style={{ marginLeft: 24 }}
            />
          </div>
        </div>

        <div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <div style={{ flex: 1 }}>
              <Text strong>Action Buttons</Text>
              <Paragraph style={{ marginTop: 8, marginBottom: 0 }}>
                <Text type="secondary">
                  Show contextual action suggestions after agent responses, enabling quick follow-up
                  actions like drilling down or comparing time periods.
                </Text>
              </Paragraph>
            </div>
            <Switch
              checked={showActionButtons}
              onChange={setShowActionButtons}
              style={{ marginLeft: 24 }}
            />
          </div>
        </div>
      </Space>
    </Card>
  );
};
